import { render, staticRenderFns } from "./MonsterEditor.vue?vue&type=template&id=7aef677e&scoped=true"
import script from "./MonsterEditor.vue?vue&type=script&lang=js"
export * from "./MonsterEditor.vue?vue&type=script&lang=js"
import style0 from "./MonsterEditor.vue?vue&type=style&index=0&id=7aef677e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aef677e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aef677e')) {
      api.createRecord('7aef677e', component.options)
    } else {
      api.reload('7aef677e', component.options)
    }
    module.hot.accept("./MonsterEditor.vue?vue&type=template&id=7aef677e&scoped=true", function () {
      api.rerender('7aef677e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/monster/MonsterEditor.vue"
export default component.exports